import { apiClient, type StepUpRequestConfig } from "./client";

// The authenticator step-up ("Confirm it's you", Q-O12) — ported from Summit Engineering's mfaApi. The API records the
// proof server-side against the person's object id and sign-in time; the SPA only carries the 6-digit code.

/** Whether this sign-in must pass the step, whether it has, and whether the person has set the app up yet. */
export interface StepUpStatus {
  required: boolean;
  verified: boolean;
  enrolled: boolean;
  /** Development persona sign-in with the bypass flag on (Development only). */
  bypassed: boolean;
  detail: string | null;
  expiresAtUtc: string | null;
  lockedUntilUtc: string | null;
  attemptsLeft: number | null;
}

/** First-time set-up: scan the QR code (a PNG data URI drawn by the API) or type the key by hand. */
export interface StepUpEnrolment {
  issuer: string;
  account: string;
  manualKey: string;
  otpAuthUri: string;
  qrCodePngDataUri: string;
}

const noPrompt: StepUpRequestConfig = { skipStepUpPrompt: true };

export const stepUpApi = {
  status: async (): Promise<StepUpStatus> => (await apiClient.get<StepUpStatus>("/session/mfa", noPrompt)).data,
  enrol: async (): Promise<StepUpEnrolment> => (await apiClient.post<StepUpEnrolment>("/session/mfa/enrol", undefined, noPrompt)).data,
  verify: async (code: string): Promise<StepUpStatus> => (await apiClient.post<StepUpStatus>("/session/mfa/verify", { code }, noPrompt)).data
};
